export const NAVIGATION_ROUTES = {
    MAIN: '/',
    SETTINGS: '/settings',
    SETTINGS_PREFERENCES: '/settings/preferences',
    SETTINGS_INTEGRATIONS: '/settings/integrations',
    SETTINGS_INTEGRATIONS_ZOHO_EDIT: '/settings/integrations/zoho-edit',
    SETTINGS_EARLY_ACCESS: '/settings/earlyaccess',
    SETTINGS_CALENDAR: '/settings/calendar',
    SETTINGS_CALENDAR_CREATE: '/settings/calendar/create',
    SETTINGS_CALENDAR_EDIT: '/settings/calendar/edit',
    SETTINGS_CALENDAR_DAY_EDIT: '/settings/calendar/editday',
    PROJECTS: '/projects',
    PROJECTS_BY_TYPE: '/projects/:typeId',
    CREATE_PROJECT: '/projects/:typeId/create',
    EDIT_PROJECT: '/projects/:typeId/edit',
    TYPES: '/types',
    PROJECT_TYPES: '/types/project',
    CREATE_PROJECT_TYPE: '/types/project/create',
    EDIT_PROJECT_TYPE: '/types/project/edit',
    SHIFT_TYPES: '/types/shift',
    CREATE_SHIFT_TYPE: '/types/shift/create',
    EDIT_SHIFT_TYPE: '/types/shift/edit',
    ABSENCE_TYPES: '/types/absence',
    CREATE_ABSENCE_TYPE: '/types/absence/create',
    EDIT_ABSENCE_TYPE: '/types/absence/edit',
    TAG_TYPES: '/types/tag',
    CREATE_TAG_TYPE: '/types/tag/create',
    EDIT_TAG_TYPE: '/types/tag/edit',
    ROLES: '/roles',
    CREATE_ROLE: '/roles/create',
    EDIT_ROLE: '/roles/edit',
    CLIENTS: '/clients',
    CREATE_CLIENT: '/clients/create',
    EDIT_CLIENT: '/clients/edit',
    EMPLOYEES: '/employees',
    CREATE_EMPLOYEE: '/employees/create',
    EDIT_EMPLOYEE: '/employees/edit',
    TIMESHEET: '/timesheet',
    TIMESHEET_IMPORT: '/timesheet/import',
    TIMESHEET_FAVORITES: '/timesheet/favorites',
    CREATE_SHIFT: '/timesheet/shift/create',
    EDIT_SHIFT: '/timesheet/shift/:shiftId/edit',
    EDIT_ABSENCE: '/timesheet/absence/:absenceId/edit',
    TIMEREPORT: '/timereport',
    TIMEREPORT_FAVORITES: '/timereport/favorites',
    TIMEBANKREPORT: '/timebankreport',
    CREATE_TIME_BANK_TRANSACTION: '/timebankreport/create',
    VACATIONREPORT: '/vacation',
    CREATE_VACATION: '/vacation/create',
    EDIT_VACATION: '/vacation/edit',
    COSTREPORT: '/costreport',
    CREATE_COST: '/costreport/create',
    EDIT_COST: '/costreport/edit',
    PROFILE: '/profile',
    PROFILE_PAYMENT_METHODS: '/profile/paymentMethods',
    PROFILE_SUBSCRIPTION: '/profile/subscription',
    PROFILE_PROJECTS: '/profile/projects',
    PROFILE_ROLES: '/profile/roles',
} as const;
